import { format } from 'date-fns';

export function getCurrentYear() {
  const date = new Date();
  return format(date, 'yyyy');
}
